const wpBlocks = (): void => {
  // WP Block Quote
  const blockQuote = document.querySelectorAll<HTMLElement>('.wp-block-quote');
  blockQuote.forEach((element) => {
    const style = getComputedStyle(element),
      color = style.color;
    element.style.setProperty('--pipe-color', color);
  });
};

export default wpBlocks;
